import ForumOutlinedIcon from '@mui/icons-material/ForumOutlined';
import { Box, type SxProps, type Theme } from '@mui/material';

/**
 * The assistant's identity mark: the forum glyph in white on the brand
 * gradient tile. It is the one place the assistant brand lives — the header
 * tile at 44px and the per-message avatar at 26px share it, so the assistant
 * reads as the same first-party entity across every panel and message.
 */
export function AssistantMark({
  size = 44,
  iconSize = 20,
  sx,
}: {
  size?: number;
  iconSize?: number;
  sx?: SxProps<Theme>;
}) {
  return (
    <Box
      aria-hidden="true"
      sx={[
        {
          alignItems: 'center',
          background: 'linear-gradient(135deg, #6B46C1, #805AD5)',
          borderRadius: size >= 40 ? 2.5 : 1.5,
          color: '#FFFFFF',
          display: 'flex',
          flexShrink: 0,
          height: size,
          justifyContent: 'center',
          width: size,
        },
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
    >
      <ForumOutlinedIcon sx={{ fontSize: iconSize }} />
    </Box>
  );
}
